import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=c2b93280&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=c2b93280&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b93280",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2b93280')) {
      api.createRecord('c2b93280', component.options)
    } else {
      api.reload('c2b93280', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=c2b93280&scoped=true", function () {
      api.rerender('c2b93280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/carWashSuperviseSystem/settlementCenter/accountFinance/detail.vue"
export default component.exports